import { get, pick } from 'lodash-es'
import { formatPics, filterParams } from '@/common/utils/format'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'
import {  isCountryChile } from '@/common/utils/i18n'

// 从后端去取哪些字段显示在当前页面上
const PARAMS_KEYS_LIST = [
  {
    key: 'accountGrantPhoto',
    format: data => (data && data.length ? data.map(item => item.key) : '')
  },
  'accountType',
  'accountBank',
  'accountBankName',
  'accountFirstName',
  'accountLastName',
  'accountCardType',
  'accountHolder',
  'accountHolderId',
  'accountAddr',
  'accountCardno',
  'beneficiaryIdType',
  'beneficiaryId',
  'bankAgentno',
  'bankAgentDigit',
  'accountCardDigit'
]

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  let revertted = pick(contractData, PARAMS_KEYS_LIST) || {}
  revertted.accountGrantPhoto = formatPics(contractData.accountGrantPhoto)
  revertted.backupAccountCardno = contractData.accountCardno
  if (!revertted.accountFirstName) {
    revertted.accountFirstName = ''
  }
  if (!revertted.accountLastName) {
    revertted.accountLastName = ''
  }
  return revertted
}


export function  submitFormat (data, temp) {
    const { signForm } = this
    const accountCardno = data.accountCardno
    const backupAccountCardno = get(signForm, 'accountInfo.backupAccountCardno')
    if (get(signForm, 'contractInfo.contractPic')) {
      data.accountGrantPhoto = get(signForm, 'contractInfo.contractPic').map(item => item.key)
    }
    if (country !== 'BR') {
      if (!temp && accountCardno !== backupAccountCardno && accountCardno !== data.confirmAccountCardno && !isCountryChile()) {
        throw new Error(i18n.gettext('两次银行卡号不一致！'))
      }
    }
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.$route.params.id,
        pathUrl: location.href,
        contractGlobal: data
      })
    }
  }

export default {
  revert,
  submitFormat
}
